export const CricketGenRules = [
  {
    category: 'MATCH ODDS',
    rules: [
      'Match Odds & Book Maker Market Will Suspend If Play Stop On Rain Or Any Other Technical Reasons..',
      "At the Moment of the Third Umpire Decision We Can't Accept Bets in Any Fancy and Match Odds",
    ],
  },
  {
    category: 'FANCY',
    rules: [
      'All fancy bets will be validated when match has been tied.',
      'All advance fancy will be suspended before toss or weather condition.',
      'In case technical error or any circumstances any fancy is suspended and does not resume result will be given all previous bets will be valid.',
      'If any case wrong rate and wrong commentary has been given in fancy that particular bets will be cancelled.',
      'In any circumstances management decision will be final related to all exchange items.',
      'In case customer make bets in wrong fancy we are not liable to delete, no changes will be made and bets will be consider as confirm bet.',
      'Due to any technical error market is open and result has come all bets after result will be deleted.',
      'Four, sixes, wide, wicket, extra run, total run, highest over and top batsman, maiden over, caught-out, no-ball, run-out, fifty and century are valid only match has been completed in case due to rain over has been reduced all other fancy will be deleted. All complete events are valid E.x 1 over run team A etc.. .',
      'Penalty runs will not be counted in any fancy.',
      'Due to mistakes in official scorecard our scorecard and results will be valid.',
      'Our exchange is not responsible for misuse of client id,master account and super master account.',
      'Minimum number of legal over has to be bowled by the bowler mentioned in the event, else the same will not be considered as valid.',
    ],
  },
  {
    category: 'PLAYER BOOKMAKER',
    rules: [
      'Suppose Either No1 Or No2 Player Score Compare To Run But Which Even IS Hire Score IS Win',
      'Explanation Of Player Bookmaker: Compare Both Player Runs At Wicket ..if V kohli Runs 22 and R.Sharma Run 20 At The Moment Of WICKET Then V KOHLI will BE Winner.',
      "If Both Player Score Is Level It's Means Virat Kohli & Rohit Sharma Both Are Either Out Match Over Is Complete, It's Mean Game Is Tie",
      'If Match Are Interpreted Due To Bed Weather Or Any Thing Else At That Time Low Score Player Run Are Not Count And Match Are Declared To ABANDONED',
    ],
  },
  {
    category: 'Other Fancy',
    rules: [
      'T-20 ,one day and test match in case current innings player and partnership are running in between match has been called off or abandoned that situation all current player and partnership results are valid.',
      '1st wicket lost to any team balls meaning that any team 1st wicket fall down in how many balls that particular fancy at least minimum one ball have to be played otherwise bets will be deleted.',
      '1st wicket lost to any team fancy valid both innings.',
      'How many balls for 50 runs any team meaning that any team achieved 50 runs in how many balls that particular fancy at least one ball have to be played otherwise that fancy bets will be deleted',
      'How many balls for 50 runs fancy any team only first inning valid.',
      'How many balls face any batsman meaning that any batsman how many balls he/she played that particular fancy at least one ball have to be played otherwise that fancy bets will be deleted.',
      'How many balls face by any batsman both innings valid.',
    ],
  },
];

export const TestMachRules = [
  {
    category: 'Session',
    rules: [
      'Complete session valid in test.',
      'Session is not completed for ex:- India 60 over run session Ind is running in case India team declares or all-out at 55 over next 5 over session will be continue in England inning.',
      '1st day 1st session run minimum 25 over will be played then result is given otherwise 1st day 1st session will be deleted.',
      '1st day 2nd session run minimum 25 over will be played then result is given otherwise 1st day 2nd session will be deleted',
      '1st day total run minimum 80 over will be played then result is given otherwise 1st day total run will be deleted',
      'Test match both advance session is valid.',
    ],
  },
  {
    category: 'Test lambi/ Inning run',
    rules: [
      'Mandatory 70 over played in test lambi paari/ Innings run. If any team all-out or declaration lambi paari/ innings run is valid',
      '2 In case due to weather situation match has been stopped all lambi trades will be deleted.',
      'In test both lambi paari / inning run is valid in advance fancy.',
    ],
  },
  {
    category: 'Test batsman',
    rules: [
      'In case batsmen is injured he/she is made 34 runs the result will be given 34 runs.',
      'Batsman 50/100 run if batsman is injured or declaration the result will be given on particular run.',
      'In next men out fancy if player is injured particular fancy will be deleted.',
      'In advance fancy opening batsmen is only valid if same batsmen came in opening the fancy will be valid in case one batsmen is changed that particular player fancy will be deleted.',
      'Test match both advance fancy batsmen run is valid.',
    ],
  },
  {
    category: 'Other fancy advance',
    rules: [
      'Four, sixes, wide, wicket, extra run, total run, highest over and top batsmen is valid only if 300 overs has been played or the match has been won by any team otherwise all these fancy will be deleted.',
    ],
  },
  {
    category: 'Concussion in Test',
    rules: [
      'All bets of one over session will be deleted in test scenario, in case session is incomplete. For example innings declared or match suspended to bad light or any other conditions.',
    ],
  },
  {
    category: 'Total Match- Events (Test)',
    rules: [
      'Minimum of 300 overs to be bowled in the entire test match, otherwise all bets related to the particular event will get void. For example, Total match caught outs will be valid only if 300 overs been bowled in the particular test match',
    ],
  },
];

export const T20MatchRules = [
  {
    category: 'Session',
    rules: [
      'Match 1st over run advance fancy only 1st innings run will be counted.',
      'For example:- 35 over run team a is playing any case team A is all-out in 33 over team a has made 150 run the session result is validated on particular run.',
      'Advance session & All Fancy is valid in only 1st innings',
    ],
  },
  {
    category: '50 over runs',
    rules: [
      'In case 50 over is not completed all bet will be deleted due to weather or any condition.',
      'Advance 50 over runs is valid in only 1st innings.',
    ],
  },
  {
    category: 'Odi / T20 batsman runs',
    rules: [
      'In case batsman is injured he/she is made 34 runs the result will be given 34 runs.',
      'In next men out fancy if player is injured particular fancy will be deleted.',
      'In advance fancy opening batsmen is only valid if same batsmen came in opening the fancy will be valid in case one batsmen is changed that particular player fancy will be deleted.',
    ],
  },
  {
    category: 'T20 over runs',
    rules: [
      'Advance 20 over run is valid only in 1st innings. 20 over run will not be considered as valid if 20 overs is not completed due to any situation.',
    ],
  },
  {
    category: 'T20 / ODI batsman runs',
    rules: [
      'In case batsman is injured he/she is made 34 runs the result will be given 34 runs.',
      'In next men out fancy if player is injured particular fancy will be deleted.',
      'In advance fancy opening batsmen is only valid if same batsmen came in opening the fancy will be valid in case one batsmen is changed that particular player fancy will be deleted.',
    ],
  },
  {
    category:
      "At the Moment of the Third Umpire Decision We Can't Accept Bets in Any Fancy and Match Odds.",
    rules: [],
  },
];

export const CricketCheeting = [
  {
    category: 'Cheating',
    rules: [
      'Cheating Of Any Kind Is Not Allowed And Customers Bets Who Are Deemed To Be Cheating Are Liable To Have Bets Made Void. Cheating Includes But Is Not Limited To; Market Price Manipulation, Court Siding, Sniping And Commission Abuse.',
      'The Site Reserves The Right To Void Any Bets That Are Under Review As Part Of Any Integrity Investigation.',
      'The Site May Void Certain Bets In A Market Or Void A Whole Market In Its Entirety As A Result Of Any Integrity Investigation.',
      "The Site's Decision In Such Integrity Cases Shall Be ﬁnal And Binding Upon The Customer.",
      'Customers Using VPN Applications To Mask Location Or Proxy Servers To Mask Device Are Liable To Having Bets Invalidated. Customers Appearing From Multiple IP Locations Are Also Liable To Having Bets Invalidated.',
    ],
  },
];

export const RulesOfTennis = [
  {
    category: 'Rules Of Tennis',
    rules: [
      'All Bets Will Stand Irrespective Of A Change Of Schedule (Or Day Of Match).',
      'All Bets Will Be Void In The Event Of A Match Starting But Not Being Completed, Except For Bets Where The Outcome Has Already Been Determined. For Example - A Game Is Abandoned At 6-4, 5-1. In This Instance.',
      'Bets On The First Set Winner Will Be Finalized As A Winner. The Only Exception To This Rule Is Where A Player Is Disqualified, After Which The Player Or Team Progressing To The Next Round Will Be Deemed The Winner.All Games Result Given By Trusted Scoring Sites And Live Tv Reference.',
      'Trading bet will not consider in our exchange.',
      'All tennis events will be settled and winner will be declared after 1st set is completed. All bets will be voided if any player retried/walkover in between 1st set or before event starts.',
      'Bet will be void any time from our system.',
    ],
  },
  {
    category: 'Cheating',
    rules: [
      'Cheating Of Any Kind Is Not Allowed And Customers Bets Who Are Deemed To Be Cheating Are Liable To Have Bets Made Void. Cheating Includes But Is Not Limited To; Market Price Manipulation, Court Siding, Sniping And Commission Abuse.',
      'The Site Reserves The Right To Void Any Bets That Are Under Review As Part Of Any Integrity Investigation.',
      'The Site May Void Certain Bets In A Market Or Void A Whole Market In Its Entirety As A Result Of Any Integrity Investigation.',
      "The Site's Decision In Such Integrity Cases Shall Be ﬁnal And Binding Upon The Customer.",
      'Customers Using VPN Applications To Mask Location Or Proxy Servers To Mask Device Are Liable To Having Bets Invalidated. Customers Appearing From Multiple IP Locations Are Also Liable To Having Bets Invalidated.',
    ],
  },
];

export const RulesOfSoccer = [
  {
    category: 'Rules Of Football',
    rules: [
      'Result Will Be Given On The Basis Of 90+2/4 Minutes.',
      'Match Odds Will Suspend While Penalty Shootout & Extra Time Between Play',
      'Extra Time Goal Is Not Consider In Result',
      '. Abandoned Or Postponed Games Are Void Unless Rearranged And Played In The Same Weekly Schedule Except For Those Bets That Have Already Been Determined At The Time Of Abandonment Or Postponement.',
      'If A Game Venue Is Changed, Bets Already Placed Will Stand, Providing The Home Team Is Still Designated As Such.',
      'If The Home And Away Team For A Listed Game Are Reversed, Then Bets Placed Based On The Original Listing Will Be Void.',
      'In 2-Way Markets Push Rules Apply, Unless Otherwise Stated. Bet Amounts On Straight Bets Are Returned, And In Parlays The Selection Is Treated As A Non-Runner. For Example - In Handicap Or Totals Betting Where The Index (Value) Of The Market Is A Whole Number, Bets Are Void And Will Be Refunded Where The Score Lands On That Number.',
      'For the cancellation of a goal, due to VAR, bets matched between the time of the goal being scored and the time at which the video assistant referee finishes the review will be voided',
      'All Settlements Are Based On Results And Statistics Provided By The Relevant League’s Governing Body:',
      'We Reserve The Right To Suspend Any Or All Betting On A Game At Any Time Without Notice.',
      'For Settlement Purposes, The Team Listed First In The Event Name Is Always Considered The Home Team. Example: Team A Vs Team B - Team A Is The Home Team.',
    ],
  },
  {
    category: 'Cheating',
    rules: [
      'Cheating Of Any Kind Is Not Allowed And Customers Bets Who Are Deemed To Be Cheating Are Liable To Have Bets Made Void. Cheating Includes But Is Not Limited To; Market Price Manipulation, Court Siding, Sniping And Commission Abuse.',
      'The Site Reserves The Right To Void Any Bets That Are Under Review As Part Of Any Integrity Investigation.',
      'The Site May Void Certain Bets In A Market Or Void A Whole Market In Its Entirety As A Result Of Any Integrity Investigation.',
      "The Site's Decision In Such Integrity Cases Shall Be ﬁnal And Binding Upon The Customer.",
      'Customers Using VPN Applications To Mask Location Or Proxy Servers To Mask Device Are Liable To Having Bets Invalidated. Customers Appearing From Multiple IP Locations Are Also Liable To Having Bets Invalidated.',
    ],
  },
];

export const RulesOfBinary = [
  {
    category: 'Binary',
    rules: [
      "All session's bets will be confirmed at the market rate only.",
      "All session's settlement price means results can be checked from the exchange's official sites.",
      'All session results will be the settlement price provided by the exchange after market close.',
      'We provide only the FUTURE price in Binary Session. You can check it from the official website of that product.',
      "Session's timings: NFY, B-NFY - Monday to Friday 10:00 A.M to 2:30 P.M GOLD, SILVER, CRUDE - Monday to Friday 10:30 A.M to 10:30 P.M",
    ],
  },
];
